export enum EditHubSettingType {
    BRANDING = 1,
    REGISTRATION = 2,
    SIGN_IN = 3,
    FOOTER = 4,
    MENU = 5,
}
